import { adminBasePath } from '../api/base.js';

// Keep this list in sync with backend src/admin/feedback-validation.ts.
export const FEEDBACK_TAGS = [
  '话术自然',
  '话术太硬',
  '产品知识错误',
  '价格错误',
  '应转人工',
  '回复过长',
  '未理解用户',
  '优秀回复',
];

export const QUICK_REPLY_TEMPLATES = [
  '您好，我是冷奇传媒的商务 kook。',
  '这次想和您聊一个品牌合作的商单。',
  '方便发下您最近的刊例和档期吗？我帮您评估合作方案。',
  '我把合作资料和案例发您，您看下方向和报价。',
  '有意向的话我先帮您锁定档期。',
];

const WECHAT_EMOJI_MAP: Record<string, string> = {
  '[微笑]': '🙂',
  '[撇嘴]': '😒',
  '[色]': '😍',
  '[发呆]': '😳',
  '[得意]': '😎',
  '[流泪]': '😢',
  '[害羞]': '😳',
  '[闭嘴]': '🤐',
  '[睡]': '😴',
  '[大哭]': '😭',
  '[尴尬]': '😅',
  '[发怒]': '😠',
  '[调皮]': '😜',
  '[呲牙]': '😁',
  '[惊讶]': '😲',
  '[难过]': '😞',
  '[酷]': '😎',
  '[冷汗]': '😰',
  '[抓狂]': '😫',
  '[吐]': '🤮',
  '[偷笑]': '🤭',
  '[可爱]': '🥰',
  '[白眼]': '🙄',
  '[傲慢]': '😏',
  '[饥饿]': '😋',
  '[困]': '😪',
  '[惊恐]': '😱',
  '[流汗]': '😓',
  '[憨笑]': '😄',
  '[大兵]': '💂',
  '[奋斗]': '💪',
  '[咒骂]': '🤬',
  '[疑问]': '❓',
  '[嘘]': '🤫',
  '[晕]': '😵',
  '[折磨]': '😖',
  '[衰]': '😩',
  '[骷髅]': '💀',
  '[敲打]': '👊',
  '[再见]': '👋',
  '[擦汗]': '😅',
  '[抠鼻]': '🤧',
  '[鼓掌]': '👏',
  '[糗大了]': '😳',
  '[坏笑]': '😏',
  '[左哼哼]': '😤',
  '[右哼哼]': '😤',
  '[哈欠]': '😪',
  '[鄙视]': '😒',
  '[委屈]': '🥺',
  '[快哭了]': '😢',
  '[阴险]': '😈',
  '[亲亲]': '😘',
  '[吓]': '😱',
  '[可怜]': '🥺',
  '[菜刀]': '🔪',
  '[西瓜]': '🍉',
  '[啤酒]': '🍺',
  '[篮球]': '🏀',
  '[乒乓]': '🏓',
  '[咖啡]': '☕',
  '[饭]': '🍚',
  '[猪头]': '🐷',
  '[玫瑰]': '🌹',
  '[凋谢]': '🥀',
  '[示爱]': '💕',
  '[爱心]': '❤️',
  '[心碎]': '💔',
  '[蛋糕]': '🎂',
  '[闪电]': '⚡',
  '[炸弹]': '💣',
  '[刀]': '🔪',
  '[足球]': '⚽',
  '[瓢虫]': '🐞',
  '[便便]': '💩',
  '[月亮]': '🌙',
  '[太阳]': '☀️',
  '[礼物]': '🎁',
  '[拥抱]': '🤗',
  '[强]': '👍',
  '[弱]': '👎',
  '[握手]': '🤝',
  '[胜利]': '✌️',
  '[抱拳]': '🙏',
  '[勾引]': '👉',
  '[拳头]': '✊',
  '[差劲]': '👎',
  '[爱你]': '🤟',
  '[NO]': '🙅',
  '[OK]': '👌',
  '[爱情]': '💑',
  '[飞吻]': '😘',
  '[跳跳]': '🦘',
  '[发抖]': '🥶',
  '[怄火]': '😤',
  '[转圈]': '🔄',
  '[磕头]': '🙇',
  '[回头]': '↩️',
  '[跳绳]': '🪢',
  '[挥手]': '👋',
  '[激动]': '🤩',
  '[街舞]': '🕺',
  '[献吻]': '😘',
  '[左太极]': '☯️',
  '[右太极]': '☯️',
  '[双喜]': '🎊',
  '[鞭炮]': '🧨',
  '[灯笼]': '🏮',
  '[发财]': '💰',
  '[K歌]': '🎤',
  '[购物]': '🛍️',
  '[邮件]': '📧',
  '[帅]': '😎',
  '[喝彩]': '🎉',
  '[祈祷]': '🙏',
  '[爆筋]': '💢',
  '[棒棒糖]': '🍭',
  '[喝奶]': '🍼',
  '[下面]': '🍜',
  '[香蕉]': '🍌',
  '[飞机]': '✈️',
  '[开车]': '🚗',
  '[高铁]': '🚄',
  '[左车头]': '🚙',
  '[车厢]': '🚃',
  '[右车头]': '🚙',
  '[多云]': '⛅',
  '[下雨]': '🌧️',
  '[钞票]': '💵',
  '[熊猫]': '🐼',
  '[灯泡]': '💡',
  '[风车]': '🌬️',
  '[闹钟]': '⏰',
  '[雨伞]': '☂️',
  '[彩球]': '🎈',
  '[钻戒]': '💍',
  '[沙发]': '🛋️',
  '[纸巾]': '🧻',
  '[药]': '💊',
  '[手枪]': '🔫',
  '[青蛙]': '🐸',
  '[旺柴]': '🐶',
};

export function escapeHtml(value: unknown): string {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

export function renderWechatEmojis(text: string): string {
  let result = escapeHtml(text);
  for (const [code, emoji] of Object.entries(WECHAT_EMOJI_MAP)) {
    result = result.replaceAll(code, emoji);
  }
  return result;
}

export function displayName(conversation: {
  customerNickname?: string | null;
  customerRemark?: string | null;
  customerWechatAlias?: string | null;
  customerWechatId?: string | null;
  friendId: number;
}): string {
  return conversation.customerNickname?.trim()
    || conversation.customerRemark?.trim()
    || readableWechatId(conversation.customerWechatAlias)
    || readableWechatId(conversation.customerWechatId)
    || `好友 ${conversation.friendId}`;
}

export function readableWechatId(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed && !trimmed.toLowerCase().startsWith('wxid_') ? trimmed : null;
}

export function botAccountDisplayName(account: {
  botNickname?: string | null;
  botWechatRecordId: number;
}): string {
  return account.botNickname?.trim() || `工作号 #${account.botWechatRecordId}`;
}

export function initialOf(value: string): string {
  const trimmed = String(value || '客').trim();
  return Array.from(trimmed)[0] || '客';
}

export function formatTime(value: string | null | undefined): string {
  if (!value) return '';
  return new Intl.DateTimeFormat('zh-CN', { hour: '2-digit', minute: '2-digit' }).format(new Date(value));
}

export function formatDay(value: string | null | undefined): string {
  if (!value) return '更早';
  const date = new Date(value);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  if (date.toDateString() === today.toDateString()) return '今天';
  if (date.toDateString() === yesterday.toDateString()) return '昨天';
  return new Intl.DateTimeFormat('zh-CN', { month: '2-digit', day: '2-digit' }).format(date);
}

export function formatRelative(value: string | null | undefined): string {
  if (!value) return '未知';
  const minutes = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 60000));
  if (minutes < 1) return '刚刚';
  if (minutes < 60) return `${minutes} 分钟前`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} 小时前`;
  return `${Math.round(hours / 24)} 天前`;
}

export function hasMessageFeedback(feedback: { rating?: string | null; tags?: string[]; comment?: string | null } | null | undefined): boolean {
  return Boolean(
    feedback &&
    (feedback.rating || (Array.isArray(feedback.tags) && feedback.tags.length > 0) || feedback.comment),
  );
}

export function statusText(message: { status: string; direction: string }): string {
  if (message.status === 'failed') return '发送失败';
  if (message.status === 'pending') return '发送中';
  return message.direction === 'out' ? '已发送' : '已送达';
}

export function isRecalledMessage(message: {
  direction?: string;
  mediaMetadata?: Record<string, unknown> | null;
}): boolean {
  const recall = message.mediaMetadata?.recall;
  if (!recall || typeof recall !== 'object' || Array.isArray(recall)) return false;
  return (recall as { recalled?: unknown }).recalled === true && message.direction === 'in';
}

export function replySourceText(message: {
  direction: string;
  thinking?: string | null;
  mediaMetadata?: Record<string, unknown> | null;
}): string | null {
  if (message.direction !== 'out') return null;
  const source = message.mediaMetadata?.replySource;
  if (source === 'ai') return 'AI回复';
  if (source === 'human') return '人工回复';
  if (source === 'system') return '系统事件';
  if (message.thinking) return 'AI回复';
  return '外部回复';
}

export function modeText(mode: string | undefined | null): string {
  if (mode === 'manual') return '人工回复';
  if (mode === 'auto') return 'AI回复';
  return mode || '';
}

export function isMiniProgramMessage(message: { msgType: number | null; content: string | null; mediaMetadata?: Record<string, unknown> | null }): boolean {
  const metadata = message.mediaMetadata ?? {};
  return (
    message.msgType === 49 ||
    message.content?.startsWith('[小程序]') === true ||
    metadata.source === 'outbound_mini_program'
  );
}

export function isMediaMessage(message: { msgType: number | null; content: string | null; mediaPath?: string | null; mediaUrl?: string | null; mediaMetadata?: Record<string, unknown> | null }): boolean {
  return (
    [3, 34, 43].includes(message.msgType ?? 0) ||
    ['[图片]', '[语音]', '[视频]'].includes(message.content || '') ||
    Boolean(message.mediaPath || message.mediaUrl || message.mediaMetadata?.imageUrl)
  );
}

export function messageMediaUrl(message: { mediaPath?: string | null; mediaUrl?: string | null; mediaMetadata?: Record<string, unknown> | null }): string {
  if (message.mediaPath) {
    const normalized = String(message.mediaPath).replaceAll('\\', '/').replace(/^\/+/, '');
    const relative = normalized.startsWith('media/') ? normalized.slice('media/'.length) : normalized;
    if (relative && !relative.includes('..')) {
      return `${adminBasePath()}/media/${relative.split('/').map(encodeURIComponent).join('/')}`;
    }
  }
  if (typeof message.mediaUrl === 'string' && /^https?:\/\//i.test(message.mediaUrl)) {
    return message.mediaUrl;
  }
  if (typeof message.mediaMetadata?.imageUrl === 'string' && /^https?:\/\//i.test(message.mediaMetadata.imageUrl)) {
    return message.mediaMetadata.imageUrl;
  }
  return '';
}

export function shouldRenderMessageText(content: string | null, hasMedia: boolean, hasMiniProgram = false): boolean {
  if (!content) return false;
  if (hasMedia && ['[图片]', '[语音]', '[视频]'].includes(content)) return false;
  if (hasMiniProgram && content.startsWith('[小程序]')) return false;
  return true;
}

export function highlight(value: string | null | undefined, term: string): string {
  const source = String(value ?? '');
  const safe = escapeHtml(source);
  if (!term) return safe;
  const index = source.toLowerCase().indexOf(term.toLowerCase());
  if (index < 0) return safe;
  return `${escapeHtml(source.slice(0, index))}<mark>${escapeHtml(source.slice(index, index + term.length))}</mark>${escapeHtml(source.slice(index + term.length))}`;
}
